<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>連絡番号の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 連絡番号１ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="連絡番号１"
                  rules="contact_num_only|max:20"
                >
                  <v-text-field
                    v-model="forms.contact_number_1"
                    :error-messages="errors"
                    dense
                    label="連絡番号１"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>連絡番号１</span>
                      <span class="ml-1">
                        ({{ forms.contact_number_1?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /連絡番号１ -->

            <!-- 連絡番号２ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="連絡番号２"
                  rules="contact_num_only|max:20"
                >
                  <v-text-field
                    v-model="forms.contact_number_2"
                    :error-messages="errors"
                    dense
                    label="連絡番号２"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>連絡番号２</span>
                      <span class="ml-1">
                        ({{ forms.contact_number_2?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /連絡番号２ -->

            <!-- 連絡番号３ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="連絡番号３"
                  rules="contact_num_only|max:20"
                >
                  <v-text-field
                    v-model="forms.contact_number_3"
                    :error-messages="errors"
                    dense
                    label="連絡番号３"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>連絡番号３</span>
                      <span class="ml-1">
                        ({{ forms.contact_number_3?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /連絡番号３ -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: "EditContactNumberDialog",
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        contact_number_1: null,
        contact_number_2: null,
        contact_number_3: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }

    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementContactNumber', {
      fetchContactNumber: 'edit',
      updateContactNumber: 'update'
    }),
    ...mapActions("DriverManifestManagementVerifyContactNumber", {
      verifyContactNumber: "update",
    }),
    /**
     * 初期値を取得/設定
     */
    setVariable () {
      this.fetchContactNumber({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     * @description 呼び出し元で設定されたコールバックを呼び出します.
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validateWithInfo().then(({ isValid, errors }) => {
        if(isValid) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyContactNumber({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateContactNumber({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      let params = this.forms
      return params;
    },
  }
}
</script>

<style scoped lang="scss">

</style>
